<app-loader [loading]="!!(initializing$ | async)"></app-loader>
@if (translationsReady$ | async) {
  <router-outlet></router-outlet>
}
